import PropTypes from 'prop-types';
import { map } from 'lodash-es';
import { CoverageTypeEnum } from './OfferBlock.enum';

/**
 * string | number type
 */
const stringNumberType = [PropTypes.string, PropTypes.number];

/**
 * coverage Item Shape
 */
const coverageItemShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType(stringNumberType).isRequired,
  type: PropTypes.oneOf(map(CoverageTypeEnum, item => item)),
});

/**
 * package Item Shape
 */
const packageItemShape = PropTypes.shape({
  ref: PropTypes.string.isRequired,
  value: PropTypes.oneOfType(stringNumberType).isRequired,
  coverages: PropTypes.arrayOf(coverageItemShape),
});

/**
 * data Item Shape
 */
const dataItemShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  showDetails: PropTypes.bool,
  packages: PropTypes.arrayOf(packageItemShape).isRequired,
  sequence: PropTypes.oneOfType(stringNumberType),
});

/**
 * extra data item shape
 */
const extraDataItemShape = {
  beneficiary: PropTypes.string,
  title: PropTypes.string,
  labelFooter: PropTypes.string,
};

/**
 * formulas item shape
 */
const formulasItemShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  sequence: PropTypes.oneOfType(stringNumberType).isRequired,
});

/**
 * strings item shape
 */
const stringsItemShape = {
  labelButton: PropTypes.string.isRequired,
  recommendation: PropTypes.string,
};

export { formulasItemShape, dataItemShape, stringsItemShape, extraDataItemShape };
